import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

/**
 * angular material
 * mat-datepicker の日付表示を1,2,3 ... 31 と表記させる
 * app.module.ts に定義された
 * { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' }
 * だとデフォルトで「1日, 2日, 3日 ... 31日」のように「日」が付与されるので
 * 表記を変更する対応
 * @class JpDateAdapter
 * @extends NativeDateAdapter
 */
@Injectable({
    providedIn: 'root'
})
export class SgJpDateAdapter extends NativeDateAdapter {
    // 日付表示変更カスタマイズ
    override getDateNames(): string[] {
        return [...Array(31).keys()].map(i => String(i + 1));
    }

    // 表示日付ゼロパディング(ゼロ埋め)カスタマイズ
    override format(date: Date, displayFormat: Object): string {
        // 日の変換
        const day: string = this.to2digit(date.getDate());
        // 月の変換
        const month: string = this.to2digit(date.getMonth() + 1);
        // 年は通常の数値
        const year: number = date.getFullYear();
        // displayFormatにdayというキーがある場合、日付入力の表示である
        if ('day' in displayFormat) {
            return `${year}/${month}/${day}`;
        }
        // 日付以外はデフォルトを戻す
        return super.format(date, displayFormat);
    }

    /**
     * 数字を01,02 などの文字列に変換する
     * ゼロパディング(ゼロ埋め)
     * @param argNumber 変換対象数値 
     * @returns 変換後文字列
     */
    private to2digit(argNumber: number): string {
        return ('00' + argNumber).slice(-2);
    }
}
